import BadgeDot from "@/components/shared/BadgeDot";
import StateBadge from "@/components/StateBadges/StateBadge";

export default function PodStateBadge({ state }: { state?: string }) {
  if (typeof state === "undefined") return null;

  function badgeDotForState(state: string) {
    switch (state) {
      case "Running":
        return <BadgeDot variant="blue" />;
      case "Failed":
        return <BadgeDot variant="red" />;
      case "Succeeded":
        return <BadgeDot variant="green" />;
      default:
        return <BadgeDot variant="gray" />;
    }
  }

  return <StateBadge badgeDot={badgeDotForState(state)} state={state} />;
}
